import React, { ReactElement } from 'react';

import { Badge } from '@sravni/react-design-system';
import { CarAccident, Deposit, House, HouseSafety, Plane, PrizeCup, WalletBag } from '@sravni/react-icons';

import styles from '../components/PromoBlock/promo-block.module.scss';

export enum TYPES {
  CREDIT = 'credit',
  OSAGO = 'osago',
  VKLADY = 'vklady',
  MFO = 'mfo',
  MORTGAGE = 'mortgage',
  MORTGAGE_INSURANCE = 'mortgageInsurance',
  VZR = 'vzr',
  LOANS = 'loans',
  CREDITS_RATING = 'creditsRating',
  SPORT_INSURANCE = 'sportInsurance',
  EDUCATION = 'education',
  KASKO = 'kasko',
}

enum COLUMNS {
  COLUMN1 = 'column1',
  COLUMN2 = 'column2',
  COLUMN3 = 'column3',
}

export interface IBlock {
  key: TYPES;
  pageUrl: string;
  picture?: JSX.Element[];
  pictureForDarkTheme?: JSX.Element[];
  title: string | JSX.Element;
  titleMobile?: string;
  label?: JSX.Element;
  text: JSX.Element;
  buttonText?: string;
  buttonTextMobile?: string;
  isForm?: boolean;
  column?: number;
  row?: number;
  subtitle?: string | JSX.Element;
  badge?: ReactElement;
  icon?: ReactElement;
  customStyle?: React.CSSProperties;
}

type BannerRow = {
  row: IBlock[];
};

type BannerColumn = {
  rows: BannerRow[];
};

type TBannerDataNew = {
  [key in COLUMNS]: BannerColumn;
};

export type TBannersData = {
  [key in TYPES]: IBlock;
};

export const BANNERS_DATA_NEW: Partial<TBannerDataNew> = {
  [COLUMNS.COLUMN1]: {
    rows: [
      {
        row: [
          {
            key: TYPES.OSAGO,
            customStyle: { flexBasis: '66.7%' },
            title: 'ОСАГО',
            subtitle: 'Поможем сравнить цены и сэкономить до\u00A05\u00A0500 ₽',
            text: (
              <span>
                Поможем сравнить цены
                <br />
                и&nbsp;сэкономить от&nbsp;800 до&nbsp;5&nbsp;500&nbsp;₽
              </span>
            ),
            pageUrl: '/osago/',
            picture: [
              <source
                key={`source-promo-osago-desktop-webp`}
                srcSet={require(`../public/images/promoBlocks/variant-b-osago.png?webp`)}
                media={`(min-width: ${styles.breakpointDesktop})`}
                type="image/webp"
              />,
              <source
                key={`source-promo-osago-desktop-png`}
                srcSet={require(`../public/images/promoBlocks/variant-b-osago.png`)}
                media={`(min-width: ${styles.breakpointDesktop})`}
                type="image/png"
              />,
              <img key={`img-promo-osago`} src={require(`../public/images/promoBlocks/variant-b-osago.png`)} alt="" />,
            ],
            pictureForDarkTheme: [
              <source
                key={`source-promo-osago-desktop-webp`}
                srcSet={require(`../public/images/promoBlocks/darkTheme/variant-b-osago.png?webp`)}
                media={`(min-width: ${styles.breakpointDesktop})`}
                type="image/webp"
              />,
              <source
                key={`source-promo-osago-desktop-png`}
                srcSet={require(`../public/images/promoBlocks/darkTheme/variant-b-osago.png`)}
                media={`(min-width: ${styles.breakpointDesktop})`}
                type="image/png"
              />,
              <img
                key={`img-promo-osago`}
                src={require(`../public/images/promoBlocks/darkTheme/variant-b-osago.png`)}
                alt=""
              />,
            ],
          },
          {
            key: TYPES.KASKO,
            customStyle: { flexBasis: '33.3%' },
            title: 'КАСКО',
            subtitle: 'Сравните цены за 1 минуту',
            icon: <CarAccident />,
            text: (
              <span>
                Поможем сравнить цены
                <br />
                и&nbsp;сэкономить от&nbsp;800 до&nbsp;5&nbsp;500&nbsp;₽
              </span>
            ),
            pageUrl: '/kasko/',
          },
        ],
      },
      {
        row: [
          {
            key: TYPES.CREDIT,
            title: 'Подбор кредита',
            subtitle: 'Покажем точную ставку, сумму и платеж по кредиту',
            text: (
              <span>
                Поможем сравнить цены
                <br />
                и&nbsp;сэкономить от&nbsp;800 до&nbsp;5&nbsp;500&nbsp;₽
              </span>
            ),
            pageUrl: '/kredity/onlajn-zayavka-na-kredit/',
            picture: [
              <source
                key={`source-promo-credits-online-desktop-webp`}
                srcSet={require(`public/images/promoBlocks/variant-b-credits-online.png`)}
                media={`(min-width: ${styles.breakpointDesktop})`}
                type="image/webp"
              />,
              <source
                key={`source-promo-credits-online-desktop-png`}
                srcSet={require(`public/images/promoBlocks/variant-b-credits-online.png`)}
                media={`(min-width: ${styles.breakpointDesktop})`}
                type="image/png"
              />,
              <img
                key={`img-promo-credits-online`}
                src={require(`public/images/promoBlocks/variant-b-credits-online.png`)}
                alt=""
              />,
            ],
            pictureForDarkTheme: [
              <source
                key={`source-promo-credits-online-desktop-webp`}
                srcSet={require(`../public/images/promoBlocks/darkTheme/variant-b-credits-online.png?webp`)}
                media={`(min-width: ${styles.breakpointDesktop})`}
                type="image/webp"
              />,
              <source
                key={`source-promo-credits-online-desktop-png`}
                srcSet={require(`../public/images/promoBlocks/darkTheme/variant-b-credits-online.png`)}
                media={`(min-width: ${styles.breakpointDesktop})`}
                type="image/png"
              />,
              <img
                key={`img-promo-credits-online`}
                src={require(`../public/images/promoBlocks/darkTheme/variant-b-credits-online.png`)}
                alt=""
              />,
            ],
          },
        ],
      },
    ],
  },
  [COLUMNS.COLUMN2]: {
    rows: [
      {
        row: [
          {
            key: TYPES.LOANS,
            title: 'Займы',
            subtitle: 'На карту за 10 минут',
            badge: <Badge color="violet" variant="primary" text="от 0%" />,
            icon: <WalletBag />,
            text: (
              <span>
                Поможем сравнить цены
                <br />
                и&nbsp;сэкономить от&nbsp;800 до&nbsp;5&nbsp;500&nbsp;₽
              </span>
            ),
            pageUrl: '/zaimy/',
          },
          {
            key: TYPES.MORTGAGE_INSURANCE,
            title: (
              <>
                Страхование
                <br />
                ипотеки
              </>
            ),
            subtitle: (
              <>
                Подберем страховку
                <br />
                для Сбера, ВТБ
                <br />и еще 8 банков
              </>
            ),
            icon: <HouseSafety />,
            text: (
              <span>
                Поможем сравнить цены
                <br />
                и&nbsp;сэкономить от&nbsp;800 до&nbsp;5&nbsp;500&nbsp;₽
              </span>
            ),
            pageUrl: '/strahovanie-ipoteki/',
          },
        ],
      },
      {
        row: [
          {
            key: TYPES.CREDITS_RATING,
            title: 'Кредитный рейтинг',
            subtitle: 'Проверьте кредитную историю на отсутствие просрочек и ошибок',
            badge: <Badge color="violet" variant="primary" text="Бесплатно" />,
            text: (
              <span>
                Поможем сравнить цены
                <br />
                и&nbsp;сэкономить от&nbsp;800 до&nbsp;5&nbsp;500&nbsp;₽
              </span>
            ),
            pageUrl: '/kredity/scoring/',
            picture: [
              <source
                key={`source-promo-credits-rating-desktop-webp`}
                srcSet={require(`../public/images/promoBlocks/variant-b-credits-rating.png?webp`)}
                media={`(min-width: ${styles.breakpointDesktop})`}
                type="image/webp"
              />,
              <source
                key={`source-promo-credits-rating-desktop-png`}
                srcSet={require(`../public/images/promoBlocks/variant-b-credits-rating.png`)}
                media={`(min-width: ${styles.breakpointDesktop})`}
                type="image/png"
              />,
              <img
                key={`img-promo-credits-rating`}
                src={require(`../public/images/promoBlocks/variant-b-credits-rating.png`)}
                alt=""
              />,
            ],
            pictureForDarkTheme: [
              <source
                key={`source-promo-credits-rating-desktop-webp`}
                srcSet={require(`../public/images/promoBlocks/darkTheme/variant-b-credits-rating.png?webp`)}
                media={`(min-width: ${styles.breakpointDesktop})`}
                type="image/webp"
              />,
              <source
                key={`source-promo-credits-rating-desktop-png`}
                srcSet={require(`../public/images/promoBlocks/darkTheme/variant-b-credits-rating.png`)}
                media={`(min-width: ${styles.breakpointDesktop})`}
                type="image/png"
              />,
              <img
                key={`img-promo-credits-rating`}
                src={require(`../public/images/promoBlocks/darkTheme/variant-b-credits-rating.png`)}
                alt=""
              />,
            ],
          },
        ],
      },
    ],
  },
  [COLUMNS.COLUMN3]: {
    rows: [
      {
        row: [
          {
            key: TYPES.VKLADY,
            title: 'Вклады',
            subtitle: 'Найдите лучшую ставку',
            icon: <Deposit />,
            text: (
              <span>
                Поможем сравнить цены
                <br />
                и&nbsp;сэкономить от&nbsp;800 до&nbsp;5&nbsp;500&nbsp;₽
              </span>
            ),
            pageUrl: '/vklady/',
          },
          {
            key: TYPES.MORTGAGE,
            title: 'Ипотека',
            subtitle: 'Выберите лучшие условия ',
            icon: <House />,
            text: (
              <span>
                Поможем сравнить цены
                <br />
                и&nbsp;сэкономить от&nbsp;800 до&nbsp;5&nbsp;500&nbsp;₽
              </span>
            ),
            pageUrl: '/ipoteka/',
          },
        ],
      },
      {
        row: [
          {
            key: TYPES.VZR,
            title: 'Туристическая страховка',
            icon: <Plane />,
            text: (
              <span>
                Поможем сравнить цены
                <br />
                и&nbsp;сэкономить от&nbsp;800 до&nbsp;5&nbsp;500&nbsp;₽
              </span>
            ),
            pageUrl: '/vzr/',
          },
          {
            key: TYPES.SPORT_INSURANCE,
            title: 'Страхование спортсменов',
            icon: <PrizeCup />,
            text: (
              <span>
                Поможем сравнить цены
                <br />
                и&nbsp;сэкономить от&nbsp;800 до&nbsp;5&nbsp;500&nbsp;₽
              </span>
            ),
            pageUrl: '/strahovanie-ns/',
          },
        ],
      },
    ],
  },
};

export const BANNERS_DATA: Partial<TBannersData> = {
  [TYPES.OSAGO]: {
    key: TYPES.OSAGO,
    isForm: true,
    picture: [
      <source
        key={`source-promo-osago-desktop-webp`}
        srcSet={require(`../public/images/promoBlocks/osago@2x.png?webp`)}
        media={`(min-width: ${styles.breakpointDesktop})`}
        type="image/webp"
      />,
      <source
        key={`source-promo-osago-desktop-png`}
        srcSet={require(`../public/images/promoBlocks/osago@2x.png`)}
        media={`(min-width: ${styles.breakpointDesktop})`}
        type="image/png"
      />,
      <img key={`img-promo-osago`} src={require(`../public/images/promoBlocks/osago@2x.png`)} alt="" />,
    ],
    pictureForDarkTheme: [
      <source
        key={`source-promo-osago-desktop-webp`}
        srcSet={require(`../public/images/promoBlocks/darkTheme/osago@2x.png?webp`)}
        media={`(min-width: ${styles.breakpointDesktop})`}
        type="image/webp"
      />,
      <source
        key={`source-promo-osago-desktop-png`}
        srcSet={require(`../public/images/promoBlocks/darkTheme/osago@2x.png`)}
        media={`(min-width: ${styles.breakpointDesktop})`}
        type="image/png"
      />,
      <img key={`img-promo-osago`} src={require(`../public/images/promoBlocks/darkTheme/osago@2x.png`)} alt="" />,
    ],
    title: 'ОСАГО',
    text: (
      <span>
        Поможем сравнить цены
        <br />
        и&nbsp;сэкономить от&nbsp;800 до&nbsp;5&nbsp;500&nbsp;₽
      </span>
    ),
    pageUrl: '/osago/?platenumber=',
    label: <Badge color={'orange'} variant={'secondary'} text={'Сервис №1 в России'} />,
    buttonText: 'Купить',
    buttonTextMobile: 'Купить',
  },
  // [TYPES.VKLADY]: {
  //   key: TYPES.VKLADY,
  //   picture: [
  //     <source
  //       key="source-promoVklady-webp"
  //       srcSet={require('../public/images/promoVklady.png?webp')}
  //       type="image/webp"
  //     />,
  //     <source key="source-promoVklady" srcSet={require('../public/images/promoVklady.png')} type="image/jpeg" />,
  //     <img key="img-promoVklady" src={require('../public/images/promoVklady.png')} alt="" />,
  //   ],
  //   title: 'Подбор вклада',
  //   text: (
  //     <span>
  //       Подберём банки с высокой
  //       <br />
  //       ставкой по вкладу
  //     </span>
  //   ),
  //   pageUrl: 'https://www.sravni.ru/vklady/',
  //   buttonText: 'Подобрать',
  // },
  [TYPES.CREDIT]: {
    key: TYPES.CREDIT,
    isForm: true,
    picture: [
      <source
        key={`source-promo-credit-desktop-webp`}
        srcSet={require(`public/images/promoBlocks/credit@2x.png`)}
        media={`(min-width: ${styles.breakpointDesktop})`}
        type="image/webp"
      />,
      <source
        key={`source-promo-credit-desktop-png`}
        srcSet={require(`public/images/promoBlocks/credit@2x.png`)}
        media={`(min-width: ${styles.breakpointDesktop})`}
        type="image/png"
      />,
      <img key={`img-promo-credit`} src={require(`public/images/promoBlocks/credit@2x.png`)} alt="" />,
    ],
    pictureForDarkTheme: [
      <source
        key={`source-promo-credit-desktop-webp`}
        srcSet={require(`public/images/promoBlocks/darkTheme/credit@2x.png`)}
        media={`(min-width: ${styles.breakpointDesktop})`}
        type="image/webp"
      />,
      <source
        key={`source-promo-credit-desktop-png`}
        srcSet={require(`public/images/promoBlocks/darkTheme/credit@2x.png`)}
        media={`(min-width: ${styles.breakpointDesktop})`}
        type="image/png"
      />,
      <img key={`img-promo-credit`} src={require(`public/images/promoBlocks/credit@2x.png`)} alt="" />,
    ],
    title: 'Подбор кредита',
    // titleMobile: 'Кредит наличными',
    text: (
      <span>
        Покажем точную ставку,
        <br />
        сумму и платеж по кредиту
      </span>
    ),
    pageUrl: '/kredity/onlajn-zayavka-na-kredit/?period=p5y&purpose=Money&amount=',
    //label: <Badge variant={'primary'} color={'violet'} text={'Акция'} />,
    buttonText: 'Подобрать',
    buttonTextMobile: null,
  },
  // [TYPES.MFO]: {
  //   key: TYPES.MFO,
  //   picture: [
  //     <source key="source-promoMfoAd-webp" srcSet={require('../public/images/promoMfo.png?webp')} type="image/webp" />,
  //     <source key="source-promoMfoAd" srcSet={require('../public/images/promoMfo.png')} type="image/jpeg" />,
  //     <img key="img-promoMfoAd" src={require('../public/images/promoMfo.png')} alt="" />,
  //   ],
  //   title: 'Получить займ',
  //   text: (
  //     <span>
  //       Выберите займ от 0%
  //       <br />в проверенных МФО
  //     </span>
  //   ),
  //   pageUrl: 'https://www.sravni.ru/zaimy/',
  //   buttonText: 'Получить',
  // },
  [TYPES.MORTGAGE_INSURANCE]: {
    key: TYPES.MORTGAGE_INSURANCE,
    picture: [
      <source
        key={`source-promo-mortgage-insurance-webp`}
        srcSet={require(`../public/images/promoBlocks/mortgage-insurance@2x.png?webp`)}
        type="image/webp"
      />,
      <source
        key={`source-promo-mortgage-insurance-png`}
        srcSet={require(`../public/images/promoBlocks/mortgage-insurance@2x.png`)}
        type="image/png"
      />,
      <img
        key={`img-promo-mortgage-insurance`}
        src={require(`public/images/promoBlocks/mortgage-insurance@2x.png`)}
        alt=""
      />,
    ],
    pictureForDarkTheme: [
      <source
        key={`source-promo-mortgage-insurance-webp`}
        srcSet={require(`../public/images/promoBlocks/darkTheme/mortgage-insurance@2x.png?webp`)}
        type="image/webp"
      />,
      <source
        key={`source-promo-mortgage-insurance-png`}
        srcSet={require(`../public/images/promoBlocks/darkTheme/mortgage-insurance@2x.png`)}
        type="image/png"
      />,
      <img
        key={`img-promo-mortgage-insurance`}
        src={require(`public/images/promoBlocks/darkTheme/mortgage-insurance@2x.png`)}
        alt=""
      />,
    ],
    title: <span>Страхование ипотеки</span>,
    text: (
      <span>
        Экономьте до{'\u00A0'}4{'\u00A0'}000{'\u00A0'}₽
        <br />
        Оплачивайте в{'\u00A0'}рассрочку
      </span>
    ),
    pageUrl: '/strahovanie-ipoteki/',
  },
  // [TYPES.VZR]: {
  //   key: TYPES.VZR,
  //   picture: [
  //     <source key="source-promoVzr-webp" srcSet={require('../public/images/promoVzr.png?webp')} type="image/webp" />,
  //     <source key="source-promoVzr" srcSet={require('../public/images/promoVzr.png')} type="image/jpeg" />,
  //     <img key="img-promoVzr" src={require('../public/images/promoVzr.png')} alt="" />,
  //   ],
  //   title: (
  //     <span>
  //       Туристическая
  //       <br />
  //       страховка
  //     </span>
  //   ),
  //   text: (
  //     <span>
  //       В любые страны
  //       <br />с экономией до 1500 ₽
  //     </span>
  //   ),
  //   pageUrl: '/vzr/',
  // },
  [TYPES.LOANS]: {
    key: TYPES.LOANS,
    picture: [
      <source
        key={`source-promo-loans-webp`}
        srcSet={
          require(`../public/images/promoBlocks/loans.png?webp`) +
          ', ' +
          require(`../public/images/promoBlocks/loans@2x.png?webp`) +
          ' 2x'
        }
        type="image/webp"
      />,
      <source
        key={`source-promo-loans-png`}
        srcSet={
          require(`../public/images/promoBlocks/loans.png`) +
          ', ' +
          require(`../public/images/promoBlocks/loans@2x.png`) +
          ' 2x'
        }
        type="image/png"
      />,
      <img key={`img-promo-loans`} src={require(`public/images/promoBlocks/loans.png`)} alt="" />,
    ],
    pictureForDarkTheme: [
      <source
        key={`source-promo-loans-webp`}
        srcSet={
          require(`../public/images/promoBlocks/darkTheme/loans.png?webp`) +
          ', ' +
          require(`../public/images/promoBlocks/darkTheme/loans@2x.png?webp`) +
          ' 2x'
        }
        type="image/webp"
      />,
      <source
        key={`source-promo-loans-png`}
        srcSet={
          require(`../public/images/promoBlocks/darkTheme/loans.png`) +
          ', ' +
          require(`../public/images/promoBlocks/darkTheme/loans@2x.png`) +
          ' 2x'
        }
        type="image/png"
      />,
      <img key={`img-promo-loans`} src={require(`public/images/promoBlocks/darkTheme/loans.png`)} alt="" />,
    ],
    title: <span>Займы</span>,
    text: (
      <span>
        Со ставкой 0%
        <br />
        за 10 минут
      </span>
    ),
    pageUrl: '/zaimy/',
  },
  // [TYPES.CREDITS_RATING]: {
  //   key: TYPES.CREDITS_RATING,
  //   picture: [
  //     <source
  //       key={`source-promo-credits-rating-webp`}
  //       srcSet={
  //         require(`../public/images/promoBlocks/credits-rating.png?webp`) +
  //         ', ' +
  //         require(`../public/images/promoBlocks/credits-rating@2x.png?webp`) +
  //         ' 2x'
  //       }
  //       type="image/webp"
  //     />,
  //     <source
  //       key={`source-promo-credits-rating-jpeg`}
  //       srcSet={
  //         require(`../public/images/promoBlocks/credits-rating.png`) +
  //         ', ' +
  //         require(`../public/images/promoBlocks/credits-rating@2x.png`) +
  //         ' 2x'
  //       }
  //       type="image/jpeg"
  //     />,
  //     <img key={`img-promo-credits-rating`} src={require(`public/images/promoBlocks/credits-rating.png`)} alt="" />,
  //   ],
  //   pictureForDarkTheme: [
  //     <source
  //       key={`source-promo-credits-rating-webp`}
  //       srcSet={
  //         require(`../public/images/promoBlocks/darkTheme/credits-rating.png?webp`) +
  //         ', ' +
  //         require(`../public/images/promoBlocks/darkTheme/credits-rating@2x.png?webp`) +
  //         ' 2x'
  //       }
  //       type="image/webp"
  //     />,
  //     <source
  //       key={`source-promo-credits-rating-jpeg`}
  //       srcSet={
  //         require(`../public/images/promoBlocks/darkTheme/credits-rating.png`) +
  //         ', ' +
  //         require(`../public/images/promoBlocks/darkTheme/credits-rating@2x.png`) +
  //         ' 2x'
  //       }
  //       type="image/jpeg"
  //     />,
  //     <img
  //       key={`img-promo-credits-rating`}
  //       src={require(`public/images/promoBlocks/darkTheme/credits-rating.png`)}
  //       alt=""
  //     />,
  //   ],
  //   title: <span>Кредитный рейтинг</span>,
  //   text: (
  //     <span>
  //       И советы по его
  //       <br />
  //       улучшению
  //     </span>
  //   ),
  //   pageUrl: '/kredity/scoring/',
  // },
};
